export default __webpack_public_path__ + "static/media/nxstep-white.76b8e1ef.svg";